export default __webpack_public_path__ + "static/media/logo_transp.1ad88e2a.png";